import React, { Component } from 'react';
import { connect } from 'react-redux';
import RadioButton from '../../../RadioButton/RadioButton';
import { updateBlockedTime, saveConfig } from '../../FilterActions';

class BlockedTimeControls extends Component {
  constructor(props) {
    super(props);
    
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = e => {
    this.props.updateBlockedTime(e.value);
    this.props.saveConfig();
  };

  render() {
    const { blockedTime, blockers } = this.props;

    return (
      <div>
        <RadioButton
          label="All time"
          id="blocked_time_all"
          name="blockedTime"
          value="all"
          checked={blockedTime === 'all'}
          onChange={this.handleChange}
          disabled={!blockers}
        />
        <RadioButton
          label="Blocked time"
          id="blocked_time_only"
          name="blockedTime"
          value="blocked"
          checked={blockedTime === 'blocked'}
          onChange={this.handleChange}
          disabled={!blockers}
        />
        <RadioButton
          label="Time without blockers"
          id="non_blocked_time"
          name="blockedTime"
          value="non-blocked"
          checked={blockedTime === 'non-blocked'}
          onChange={this.handleChange}
          disabled={!blockers}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  const chart = state.filters.chart;
  return {
    blockedTime: state.filters[chart].blockedTime || 'all',
    blockers: state.filters[chart].blockers
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveConfig: () => dispatch(saveConfig()),
    updateBlockedTime: (vals) => dispatch(updateBlockedTime(vals)),
  };
};

const connected = connect(mapStateToProps, mapDispatchToProps)(BlockedTimeControls);
export { connected as BlockedTimeControls, BlockedTimeControls as UnconnectedBlockedTimeControls };
